module.exports = __webpack_public_path__ + "img/background-3.d22a0b02.jpg";